module.exports = __webpack_public_path__ + "img/1_06.f7dcf89b.jpg";